import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
import { bonuses } from '../data/bonuses';
import { bonusTotalValue, totalBonuses } from '../data/offer';
export function BonusSection() {
  return <section className="bg-stage tech-grid py-16 sm:py-20" aria-labelledby="bonus-title" data-id="element-20" data-mp="22f3erh9dfjom">
      <div className="mx-auto max-w-5xl px-4" data-id="element-21" data-mp="1yfcqplb8bhns">
        <div className="text-center" data-id="element-22" data-mp="1aogu8avtvya7">
          <span className="metal-surface inline-flex items-center gap-2 rounded-md px-4 py-2 text-xs font-extrabold uppercase tracking-[.15em] text-navyDeep" data-id="element-23" data-mp="1apiff86k615n">
            <GiftIcon className="h-4 w-4" aria-hidden="true" data-id="element-24" data-mp="1jgr57uejs7si" /> Included at no extra cost
          </span>
          <h2 id="bonus-title" className="mt-4 text-3xl font-extrabold text-white sm:text-4xl" data-id="element-25" data-mp="1eqaqm6yzqg4k">
            The {totalBonuses} strategic bonuses
          </h2>
        </div>

        <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-26" data-mp="qydeeermpm2x">
          {bonuses.map((bonus, index) => {
          const Icon = bonus.icon;
          return <motion.article key={bonus.title} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.3,
            delay: index * 0.05,
            ease: [0.23, 1, 0.32, 1]
          }} className={`flex flex-col rounded-xl border border-silverEdge bg-navyDeep p-6 shadow-card ${bonus.wide ? 'md:col-span-2' : ''}`} data-id="element-27" data-mp="29rbh0wkl17ym" data-mpi={index}>
                <div className="flex items-center justify-between gap-4" data-id="element-28" data-mp="1vs20twwdmdun">
                  <div className="flex items-center gap-3" data-id="element-29" data-mp="1vuej6b61qq88">
                    <span className="metal-surface flex h-10 w-10 items-center justify-center rounded-md text-navyDeep" data-id="element-30" data-mp="20qloc1qmbxp4">
                      <Icon className="h-5 w-5" aria-hidden="true" data-id="element-31" data-mp="25rsyg7g8h8yy" />
                    </span>
                    <p className="text-[11px] font-extrabold uppercase tracking-[.16em] text-silverDark" data-id="element-32" data-mp="3c6ac2vbp50qz">
                      Bonus {bonus.number}
                    </p>
                  </div>
                  <p className="text-xs font-bold text-silverDark" data-id="element-33" data-mp="1h1u6bv6i7i5o">
                    <span className="line-through" data-id="element-34" data-mp="1c53pv6qsekjq">Real value {bonus.value}</span>
                    <span className="metal-surface ml-2 rounded-md px-2 py-1 text-[11px] font-extrabold uppercase tracking-wide text-navyDeep" data-id="element-35" data-mp="1q4lkw3uoeu1j">
                      Free
                    </span>
                  </p>
                </div>

                <h3 className="mt-4 text-lg font-extrabold leading-tight text-white" data-id="element-36" data-mp="ydffb7w6s44v">{bonus.title}</h3>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-silver" data-id="element-37" data-mp="tfdyktm8ggwk">{bonus.description}</p>

                <p className="mt-4 rounded-lg border-l-4 border-silver bg-white/5 px-4 py-3 text-sm font-semibold text-silverBright" data-id="element-38" data-mp="176ipn7bjc0va">
                  {bonus.benefit}
                </p>
              </motion.article>;
        })}
        </div>

        <div className="mt-8 flex flex-col items-center justify-between gap-5 rounded-xl border border-silver/50 bg-navyPanel px-6 py-6 text-center sm:flex-row sm:text-left" data-id="element-39" data-mp="anusuf0tqoqu">
          <div data-id="element-40" data-mp="5a4n1c6ptyo2">
            <p className="text-xs font-extrabold uppercase tracking-[.18em] text-silverDark" data-id="element-41" data-mp="5amrgw3j7j72">
              Value of all {totalBonuses} bonuses
            </p>
            <p className="mt-1 font-display text-2xl font-extrabold text-silver line-through decoration-danger decoration-2" data-id="element-42" data-mp="3moi53feh7364">
              {bonusTotalValue}
            </p>
          </div>
          <div className="sm:text-right" data-id="element-43" data-mp="janq04wbqejd">
            <p className="text-xs font-extrabold uppercase tracking-[.18em] text-silverDark" data-id="element-44" data-mp="o8pcz0wvey04">Your price today</p>
            <p className="mt-1 font-display text-3xl font-extrabold text-white" data-id="element-45" data-mp="9chrlx9q7qj9">FREE</p>
          </div>
        </div>

        <p className="mt-4 text-center text-xs font-bold uppercase tracking-[.14em] text-silverDark" data-id="element-46" data-mp="e9hxa72nyr9u">
          Only included in this offer
        </p>
      </div>
    </section>;
}